import { PcApiResponse } from '@/api/pc-api/types';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { TaxInvoiceIssuanceStatus } from '@/pages/:AUTH_INFO_ID/settle/taxInvoiceIssuance/constants/status';
import { api } from '@/utils/api';

export type SettleTaxInvoiceIssuance = {
  id: string;
  month: string;
  companyName?: string;
  requestOrganizationName?: string;
  settleId?: string;
  settleName?: string;
  supplyPrice: number;
  vat: number;
  totalPrice: number;
  managerEmail: string;
  taxInvoiceIssuanceStatus: keyof typeof TaxInvoiceIssuanceStatus;
};

type GetTaxInvoiceIssuanceListParams = {
  start: string;
  end: string;
};

export const getTaxInvoiceIssuanceList = ({ start, end }: GetTaxInvoiceIssuanceListParams) => {
  return api<PcApiResponse<SettleTaxInvoiceIssuance[]>>('get', `/pc-api/v1/${PREFIX_PATH}/tax-invoice-issuance/list`, {
    start,
    end
  });
};
